// src/adminDashboard/NewAdminDashboard.tsx
// Entry point for the new admin dashboard

import { SnackbarProvider } from 'notistack';
import React from 'react';

import AdminProviders from './app/providers';
import AdminRouter from './app/router';

const NewAdminDashboard: React.FC = () => {
    return (
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={3000}
        >
            <AdminProviders>
                <AdminRouter />
            </AdminProviders>
        </SnackbarProvider>
    );
};

export default NewAdminDashboard;
